import React                         from 'react';
import { arrayRailsLeft as tooltip } from 'pu-data/Tooltips';
import TextComponent                 from './TextComponent';

const ArrayRailsLeft = (props) => {
  const name = 'rails_left';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="Left rail"
      name={name}
      value={props.parameters[name] || ''}
      onChange={props.onChange || onChange}
      tooltip={tooltip}
      groupName={props.groupName} />
  );
};

ArrayRailsLeft.defaultProps = {};

export default ArrayRailsLeft;
